import Vue from 'vue'
const ModalBus = new Vue()

export default {
  install(Vue) {
    Vue.prototype.$modalBus = ModalBus
    Vue.prototype.$alert = function (message, color = 'success') {
      ModalBus.$emit('ALERT', {
        message: message,
        color: color,
      })
    }
    Vue.prototype.$alertHtml = function (message) {
      ModalBus.$emit('ALERT_HTML', message)
    }
    Vue.prototype.$verify = function (message, response) {
      ModalBus.$emit('VERIFY', { message: message, response: response })
    }
    Vue.prototype.$verifyHtml = function (message, response) {
      ModalBus.$emit('VERIFY_HTML', { message: message, response: response })
    }
    Vue.prototype.$prompt = function (title, message, callback) {
      ModalBus.$emit('PROMPT', {
        title: title,
        message: message,
        callback: callback,
      })
    }
    Vue.prototype.$password = function (response) {
      ModalBus.$emit('PASSWORD', { response: response })
    }
    Vue.prototype.$notify = function (message) {
      ModalBus.$emit('NOTIFY', message)
    }
  },
}
